import {
  getMockTestCourses,
  getMockTestList,
  setMockTestQueryData,
} from '@/actions/mock-test';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row } from 'reactstrap';

function MockTestSidebar({ component, courseSlug = null }) {
  const dispatch = useDispatch();
  const [currentSearchValue, setCurrentSearchValue] = useState(null);
  const query = useSelector(
    (state: any) => state?.MockTestReducer?.query?.mockTestLanding
  );
  const courseQuery = useSelector(
    (state: any) => state?.MockTestReducer?.query?.mockTestCourses
  );

  const handleChange = (e) => {
    setCurrentSearchValue(e.target.value);
    e.preventDefault();
    if (component == 'Tests') {
      const modifiedQuery = {
        ...query,
        page: 1,
        per_page: 10,
        title: e.target.value,
        course: courseSlug,
      };
      dispatch(
        setMockTestQueryData({ name: 'mockTestLanding', value: modifiedQuery })
      );
      dispatch(getMockTestList({ data: modifiedQuery }));
    } else {
      const modifiedQuery = {
        ...courseQuery,
        page: 1,
        per_page: 12,
        course: e.target.value,
      };
      dispatch(
        setMockTestQueryData({ name: 'mockTestCourses', value: modifiedQuery })
      );
      dispatch(getMockTestCourses({ data: modifiedQuery }));
    }
  };

  return (
    <div className="mock-test-sidebar">
      <Row>
        <Col md="12">
          <div
            className="mock-test-search bg-white "
            style={{
              borderRadius: '8px',
              boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
            }}
          >
            <>
              <h5>Search {component}</h5>
              <form>
                <input
                  value={currentSearchValue}
                  type="text"
                  className="border-0 py-2 px-3"
                  onChange={handleChange}
                  name="search"
                  placeholder="Search Here..."
                  autoComplete="off"
                  style={{
                    borderRadius: '20px',
                    background: '#F0F2F5',
                  }}
                />
              </form>
            </>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default MockTestSidebar;
